export default __webpack_public_path__ + "static/media/logo_white.05817950.png";